import { lazyShowFullComposeInEditMode } from 'owa-calendar-compose-form-store';
import { getOpxHostApi } from 'owa-opx';
import { getPlt } from 'owa-plt-data';

export function initializeOpx() {
    const opxHostApi = getOpxHostApi();
    if (opxHostApi.registerNewButtonHandler) {
        // If opxHostApi has registerNewButtonHandler, then register it
        opxHostApi.registerNewButtonHandler(() =>
            lazyShowFullComposeInEditMode.importAndExecute(
                null /* event */,
                null /* eventScope */,
                false /* itemHasUpdates */,
                'TeamsNewEventButton' /* FullComposeEntrySourceType */,
                'Modal' /* viewType */,
                null /* extractionSourceId */
            )
        );
    }
    if (opxHostApi.sendPLTDataPoint) {
        const plt = getPlt();
        if (plt) {
            opxHostApi.sendPLTDataPoint('Surface', plt);
        }
    }
}
